import { useState } from "react";
import { Route, Switch } from "react-router-dom";
import algoliasearch from "algoliasearch";

import { InstantSearch } from "react-instantsearch-dom";

import Navbar from "./Navbar";
import Search from "./Search";

const searchClient = algoliasearch(
  "MG03GQ3NFO",
  "9651f22f00fa9447bfaa053592f7fb7f"
);

export default function Main() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <InstantSearch searchClient={searchClient} indexName="christmas">
      <Search searchClient={searchClient} />
    </InstantSearch>
  );
}
